const getSubdomain = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    if (parts.length > 2) {
        return parts[0];
    }

    return null;
};

const getApiConfig = () => {
    const subdomain = getSubdomain();

    // if (subdomain) {
    //     return {
    //         API_URL: `https://${subdomain}-apis.haazriapp.com/api/`,
    //         API_BASE_URL: `https://${subdomain}-apis.haazriapp.com`
    //     };
    // }

    return {
        API_URL: process.env.REACT_APP_API_URL,
        API_BASE_URL: process.env.REACT_APP_API_BASE_URL
    };
};

export const config = {
    ...getApiConfig(),
    getSubdomain: getSubdomain
};

export default config;